import { auditReports } from '@mi-front/api-clients';
import { GipExportConditionsValues } from '../types';

export function gipExportConditionsValuesToApi(
  values: GipExportConditionsValues,
): auditReports.GipEvidenceExportConditionsDto {
  return {
    minEfficiency: values.enableEfficiency ? values.minEfficiency : false,
  } as auditReports.GipEvidenceExportConditionsDto;
}

export function gipExportConditionsValuesFromApi(
  values: auditReports.GipEvidenceExportConditionsDto,
): GipExportConditionsValues {
  return {
    enableEfficiency: values.minEfficiency !== false,
    minEfficiency: values.minEfficiency === false ? 0 : values.minEfficiency!,
  };
}
